import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import EcoProButton from "../../../../../../components/shared/button/button";
import { BMC_SHENLONG_SERVICE_TYPES, NATIVE_APP_PRINTER_CATEGORY } from "../../../../../../constants/AppConstants";
import { BOSPageContext } from "../../../../BenefitOfSuppliesWrapper";
import { getNativeAppQueryParamsValuesByKey } from "../../../../../../constants/AppMethod";
import BtnWhiteArrowIcon from "../../../../../../assets/images/benefitofsuppliespage/button-arrow-mark-white.svg";
import SkipModal from "../../../SkipModal/SkipModal";
import BPlusBenefitPoints from "../../../../../../components/Web/Customer/BrotherPlus/BPlusBenefitPoints/BPlusBenefitPoints";
import LearnMore from "../../../LearnMore/LearnMore";

const Overview = (props) => {
    const { t } = useTranslation(["translation"]);
    const { handleDisplayContent } = props;
    const printerCategory = getNativeAppQueryParamsValuesByKey("new_printer")?.toUpperCase() || null;
    const {
        toggleModal,
        handleModalState,
        modalState,
        handleGetStarted
    } = useContext(BOSPageContext);

    return (
        <>
            <h1>{t('BROTHER_PLUS.BROTHER_CONNECT_MODAL.JOIN_FOR_FREE')}</h1>
            <div className="benefit-points">
               <BPlusBenefitPoints />
            </div>
            <div className="loyalty-pgm-join-free-txt-container">
                {
                    (printerCategory === NATIVE_APP_PRINTER_CATEGORY.NEW) &&
                    <div className="trial-content-wrapper">
                        <p>{t('BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.DISCOUNT_OFFER_TXT')}</p>
                    </div>
                }
            </div>
            <div className="get-started-container">
                <EcoProButton onBtnClick={() => handleDisplayContent('Confirmation')}>
                    {t('BROTHER_PLUS_BENEFIT_OF_SUPPLIES_PAGE.GETSTARTED_TXT')}
                    <span><img src={BtnWhiteArrowIcon} alt='white-arrow' title="white-arrow"/></span>
                </EcoProButton>
            </div>
             <div className="learn-more-container">
                <LearnMore type={BMC_SHENLONG_SERVICE_TYPES.BPLUS}/>
            </div>
            <SkipModal 
                modalState={modalState} 
                toggleModal={toggleModal} 
                handleBackBtn = {() => handleModalState(false)}
                handleContinueBtn = {handleGetStarted}
            />
        </>
    )
};

export default Overview;